
import api_list from "@/constant/apiUrl";
import app_config from "@/constant/config";
import { getLanguage } from "@/utility/helper/generalHandler";
import { startRequest } from "@/utility/helper/requestHelper";

export const getBlogList = async (params:any) => {
  const apiData = {
    url: api_list.blog,
    method: "GET",
    params: {
      ...params,
      lang: getLanguage()
    },
    headers: {
      lang: getLanguage()
    }
  };

  return startRequest(apiData, app_config.api_static);
};

export const getFeaturedBlogList = async (params:any) => {
  const apiData = {
    url: api_list.blog + '/featured',
    method: "GET",
    params: {
      ...params,
      lang: getLanguage()
    },
    headers: {
      lang: getLanguage()
    }
  };

  return startRequest(apiData, app_config.api_static);
};

export const getDetailBlog = async (params:any) => {
  const apiData = {
    url: api_list.blog + `/${params.id}`,
    method: "GET",
    params: {
      lang: params.lang
    },
     headers: {
      lang: params.lang
    },
  };

  return startRequest(apiData, app_config.api_static);
};